<script>
import appConfig from "@/app.config";
import loadingVue from "@/components/loading.vue";

import axios from "axios";

export default {
  components: { loadingVue },
  page: {
    title: "Nilai Ujian",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Nilai Ujian",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Nilai",
          active: true,
        },
      ],
      isLoading: true,
      setError: null,
      setScore: [],
      dataLatihan: [],
      dataValue: null,
      vert: null,
      listHasilUjian: [],
      listHasilUjianAkademik: [],
      listPaketSoal: [],
      detailSoal: [
        {
          paket: "Test Kecerdasan",
        },
        {
          paket: "Test Kepribadian",
        },
        {
          paket: "Test Kecermatan",
        },
      ],
    };
  },
  mounted() {
    this.getScore();
  },
  methods: {
    async getScore() {
      this.isLoading = true;
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/get-scores?is_ujian=0&kecermatan=1&is_exam=0"
        )
        .then((response) => {
          const filteredScores = response.data.data
            .flatMap((entry) => entry.student_score_subjects)
            .flatMap((subject) => subject.student_score_subject_details);

          this.setScore = filteredScores;
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError = error.response.data.error;
          this.$store.commit("setError", error.response.data.error);
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },

    printCertificate() {
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          `/export/certificate?is_ujian=0&is_exam=0&kecermatan=1&user_id=${this.$store.getters.getLoggedInUserId}`
      );
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <div>
    <div v-if="isLoading" class="container-fluid">
      <loading-vue style="padding: 5%;"></loading-vue>
    </div>

    <template v-else>
      <template v-if="setError">
        <div class="my-5 text-center">
          <p class="fs-3">
            <strong>{{ setError }} Silahkan hubungi admin.</strong>
          </p>
        </div>
      </template>

      <template v-else-if="setScore.length === 0">
        <div class="my-5 text-center">
          <p><strong>Tidak ada nilai saat ini.</strong></p>
        </div>
      </template>

      <template v-else>
        <div class="d-flex justify-content-end mb-2 gap-3">
          <b-button
            block
            variant="purple"
            class="d-flex align-items-center gap-2"
            @click="printCertificate()"
            style="font-size: 14px;padding-left: 20px !important;padding-right: 20px !important;"
          >
            <b-icon-printer></b-icon-printer>
            Cetak Sertifikat
          </b-button>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="text-center">ID Soal</th>
                <th>Name</th>
                <th class="text-center">Jumlah Soal</th>
                <th class="text-center">Soal Terjawab</th>
                <th class="text-center">Benar</th>
                <th class="text-center">Salah</th>
                <th class="text-center">Nilai</th>
                <th class="text-center">Status</th>
              </tr>
            </thead>
            <template v-for="(score, index) in setScore">
              <tbody :key="index" v-if="score.soals">
                <tr :class="index % 2 == 0 ? 'bg-light' : ''">
                  <td class="d-flex justify-content-center">
                    <div
                      class="text-center rounded-pill"
                      style="width: 60px;border: 1px solid #ccc;"
                    >
                      {{ score.soal_id }}
                    </div>
                  </td>
                  <td class="text-uppercase">
                    {{ score.soals.name }}
                  </td>
                  <td class="text-center">
                    {{ score.number_of_questions_detail }}
                  </td>
                  <td class="text-center">
                    {{ score.answered_questions_detail }}
                  </td>
                  <td
                    v-if="
                      score.soals.name !== 'KEPRIBADIAN' ||
                        score.soals.name === 'KEPRIBADIAN SKD'
                    "
                    class="text-center"
                  >
                    {{ score.amount_correct_detail }}
                  </td>
                  <td
                    v-if="
                      score.soals.name !== 'KEPRIBADIAN' ||
                        score.soals.name === 'KEPRIBADIAN SKD'
                    "
                    class="text-center"
                  >
                    {{ score.amount_wrong_detail }}
                  </td>
                  <td
                    v-if="
                      score.soals.name !== 'KEPRIBADIAN' ||
                        score.soals.name === 'KEPRIBADIAN SKD'
                    "
                    class="text-center"
                  >
                    {{ score.score_detail }}
                  </td>
                  <td colspan="3" v-else class="text-center">
                    {{ score.score_detail }}
                  </td>
                  <td class="text-center">
                    {{ score.is_ms_detail ? "MS" : "TMS" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </table>
        </div>
      </template>
    </template>
  </div>
</template>
